
import { dldl, goto, yyyy } from "../store.svelte"

let signOut = () => {
	yyyy.sesh = {};
	yyyy.livewires = [];
	dldl('Usercard.svelte', 'Signing out user')
	goto("/");
	return true;
};

export default signOut
